import _version from "./version.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printVersion = exports.escapeHtml = exports.onNodeRemove = exports.detectSSR = exports.nodeToString = exports.task = void 0;
const version_js_1 = _version;
/** Creates a new Task using setTimeout() */

const task = task => setTimeout(task, 0);

exports.task = task;

const nodeToString = node => {
  const tmpNode = document.createElement("div");
  tmpNode.appendChild(node.cloneNode(true));
  return tmpNode.innerHTML;
};

exports.nodeToString = nodeToString;

const detectSSR = () => {
  // @ts-ignore
  const isDeno = typeof Deno !== "undefined";
  const hasWindow = typeof window !== "undefined" ? true : false;
  return typeof _nano !== "undefined" && _nano.isSSR || isDeno || !hasWindow;
};

exports.detectSSR = detectSSR;

function isDescendant(desc, root) {
  // @ts-ignore
  return !!desc && (desc === root || isDescendant(desc.parentNode, root));
} // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver


const onNodeRemove = (element, callback) => {
  let observer = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      mutation.removedNodes.forEach(removed => {
        if (isDescendant(element, removed)) {
          callback();

          if (observer) {
            // allow garbage collection
            observer.disconnect(); // @ts-ignore

            observer = undefined;
          }
        }
      });
    });
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
};

exports.onNodeRemove = onNodeRemove; // https://stackoverflow.com/a/6234804

const escapeHtml = unsafe => {
  if (unsafe && typeof unsafe === "string") return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
  return unsafe;
};

exports.escapeHtml = escapeHtml;

const printVersion = () => {
  const info = `Powered by nano JSX v${version_js_1.VERSION}`;
  console.log(`%c %c %c %c %c ${info} %c http://nanojsx.io`, "background: #ff0000", "background: #ffff00", "background: #00ff00", "background: #00ffff", "color: #fff; background: #000000;", "background: none");
};

exports.printVersion = printVersion; //# sourceMappingURL=helpers.js.map

export default exports;